<template>
  <span>
    <template v-if="$hasPermission('view_app_details')">
      <router-link
        :to="{ name: 'app-edit', params: { appHash: app.hash } }"
        class="font-weight-bold text-primary"
      >
        {{ app.app_name }}
      </router-link>
    </template>

    <template v-else>
      <span>{{ app.app_name }}</span>
    </template>
  </span>
</template>

<script>
export default {
  name: 'AppName',
  props: {
    app: {
      type: Object,
      required: true,
    },
  },
}
</script>
